exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host .container {\n  padding-top: 70px; }\n  :host .container .breadcrumb {\n    background-color: transparent;\n    margin-bottom: 0;\n    margin-top: 10px; }\n  :host .container .form-group {\n    width: 40%; }\n    :host .container .form-group a {\n      text-decoration: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/components/event/event-creation/event-creation.component.scss
// module id = 175
// module chunks = 0